import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowRight, Calendar } from "lucide-react";
import api from "../lib/api";
import { formatDate as fmt } from "../lib/date";
import { useContent } from "../context/ContentContext";
import HeroBackdrop from "../components/HeroBackdrop";

export default function News() {
  const { t } = useContent();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/news").then(({ data }) => setNews(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="news-page">
      <section className="relative overflow-hidden bg-[#0F2744] py-16 lg:py-20">
        <HeroBackdrop sectionKey="news" image={t("img.news", "https://customer-assets-39nsmqrw.emergentagent.net/job_rospa-wm-portal/artifacts/2zzeealx_image.png")} />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="eyebrow">Club news</span>
          <h1 className="mt-4 text-4xl sm:text-5xl font-extrabold text-white">Latest from the club</h1>
          <p className="mt-4 text-lg text-slate-200 max-w-2xl">Member achievements, event round-ups and club updates.</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {loading ? (
          <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-[#0F2744]" /></div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {news.map((n) => (
              <Link key={n.id} to={`/news/${n.id}`} data-testid={`news-card-${n.id}`} className="group rounded-2xl overflow-hidden bg-white border border-slate-200 hover:shadow-xl hover:-translate-y-1 transition-all flex flex-col">
                <div className="h-48 overflow-hidden">
                  <img src={n.image_url} alt={n.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-2 text-xs text-slate-400 mb-2">
                    <Calendar className="h-3.5 w-3.5" /> {fmt(n.created_at)}
                  </div>
                  <h3 className="font-bold text-lg text-[#0F2744] leading-snug">{n.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 line-clamp-3 flex-1">{n.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-blue-600">Read more <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" /></span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
